export default {"src":"/_next/static/media/arrow.1aa9dd13.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};